import { FormField } from "./FormField";

interface EntityDetailsProps {
  details: {
    legalType: string;
    entityNameEn: string;
    vatTrn: string;
    submissionDate?: string;
    entityNameAr: string;
    effectiveDate: string;
    TIN: string,
    email: string,
    mobile: string,
    emarataxToken: string,
    verificationStatus: string,
    msgCode: string,
    msgDesc: string,
  },
  actionType?:string
}

export const EntityDetailsSection = ({ details,actionType }: EntityDetailsProps) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-xl font-bold text-foreground text-center">{actionType==='delink' ? 'Delinking - ' : ''}Entity Details</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
         <FormField
          label="TIN"
          value={details?.TIN}
          disabled
        />
        <FormField
          label="Email"
          value={details?.email}
          disabled
        />
       <FormField
          label="Mobile"
          value={details?.mobile}
          disabled
        />
        <FormField
          label="Legal Type"
          value={details?.legalType}
          disabled
        />
        <FormField
          label="Entity Legal Name in English"
          value={details?.entityNameEn}
          disabled
        />
        <FormField
          label="Entity Legal Name in Arabic"
          value={details?.entityNameAr}
          disabled
        />
        <FormField
          label="VAT TRN"
          value={details?.vatTrn}
          disabled
        />
        <FormField
          label="Effective Date of Registration / Joining VAT Group"
          value={details?.effectiveDate}
          disabled
        />
        {((details?.verificationStatus==='True' &&  actionType=='reverify' ) || ( details?.verificationStatus==='False' &&  !actionType) ) &&
          <FormField
            label="Message Description"
            value={details?.msgDesc}
            disabled
          />
        }
      </div>
    </div>
  );
};
